import ToggleInput from 'Common/Components/ToggleInput';
import styled from 'styled-components';
import colors from 'Styles/colors';

export const Label = styled.div`
  font-size: 12.5px;
  font-weight: normal;
  letter-spacing: 0.09px;
  color: ${({ theme }) => theme.text.runAgentInputLabel};
  padding-bottom: 5px;
  padding-right: 15px;
`;
Label.displayName = 'Label';

export const Field = styled.input`
  padding: 9px 53px 8px 15px;
  box-shadow: inset 0 -1px 0 0 ${(props) => (props.failed ? 'red' : props.theme.shadows.inputInset)};
  background-color: ${({ theme }) => theme.textfield.background};
  color: ${({ theme }) => theme.text.runAgentInput};
  height: 34px;
  border: 0;
  color: ${({ theme }) => theme.textfield.text};
  ${({ disabled }) => {
    if (!disabled) return null;
    return `
      cursor: not-allowed;
      `;
  }}
`;
Field.displayName = 'Field';

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 8px 0 0;
  padding-bottom: 21px;
  &[required] {
    ${Label}::after {
      content: ' *';
      color: ${colors.redPink};
    }
  }
`;
FieldWrapper.displayName = 'FieldWrapper';

export const FieldMessage = styled.div`
  font-size: 11.5px;
  font-weight: normal;
  color: ${({ theme }) => theme.text.modalDescription};
  margin-top: 8px;
`;

export const PasswordInput = styled(ToggleInput)`
  padding: 0px 8px 0 0;
  & >:first-child {
    margin-bottom: 5px;
  }
  svg {
    top: 40px;
    right: 17px;
  }
  input {
    box-shadow: inset 0 -1px 0 0 ${({ theme }) => theme.shadows.inputInset};
  }
`;
PasswordInput.displayName = 'PasswordInput';
